import React, { Component } from 'react'
import { observer } from 'mobx-react'

import SurveyDataImportStore from './SurveyDataImportStore'
import Panel from '../../../../UniformComponents/Panel'
import Button from '../../../../UniformComponents/Button'
import Checkbox from '../../../form/Checkbox'
import DataTable from '../../../DataTable'
import Loader from '../Loader'

import './surveyDataImport.scss'

@observer
class SurveyDataImport extends Component {
    constructor(props) {
        super(props)
        this.store = props.store
        this.history = props.history
        this.SurveyDataImportStore = new SurveyDataImportStore(this.store, this.history)
    }

    componentDidMount() {
        this.store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'surveyDataImport',
                url: '/intranet/surveyDataImport',
                title: 'Survey Data Import',
            },
        ]
    }

    renderDetails = () => (
        <Panel>
            <Panel cssClass="general">
                <h4>General Info</h4>
                <ol>
                    <li>
                        The CSV file needs to be
                        {' '}
                        <strong>comma delimited</strong>
                        {' '}
                        with
                        {' '}
                        <strong>&quot; text qualifiers</strong>
                        {' '}
                        wrapping string values. OpenOffice Calc provides this functionality.
                    </li>
                    <li>
                        &quot;startDate&quot; and &quot;completedDate
                        &quot; need to be formatted as
                        {' '}
                        <strong>dd/MM/yyyy HH:mm:ss</strong>
                    </li>
                    <li>
                        The first column needs to be the &quot;ID&quot;; field,
                        {' '}
                        which is an incremental number for each row. ie 1,2,3,4..
                    </li>
                    <li>
                        Please ensure the langcode field is filled
                        {' '}
                        out with a valid langcode eg en_GB
                    </li>
                </ol>
            </Panel>
            {this.SurveyDataImportStore.texts.map((element) => (

                <Panel cssClass={element.key}>
                    <h4>{element.name}</h4>
                    <p>{element.value}</p>
                </Panel>

            ))}
        </Panel>
    )

    renderFilters = () => {
        const { handleInput, uploadFile, request, pending } = this.SurveyDataImportStore
        return (
            <Panel>
                {pending ? <Loader show /> : null}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <label>Survey ID:</label>
                    <input type="text" name="id" className="inputFeild" onChange={(e) => handleInput(e, 'surveyId')} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <label>Lang Code (locale):</label>
                    <input type="text" className="inputFeild" name="lang" onChange={(e) => handleInput(e, 'langCode')} value={request.langcode} />
                </div>
                <div>
                    <input type="file" className="inputFeild" onChange={(e) => handleInput(e, 'file')} />
                </div>
                <Button cssClass="regular primary" onClick={uploadFile}>Upload as Comma delimited CSV</Button>
            </Panel>
        )
    }

    renderResultPanel = () => {
        const {
            responseMetadata,
            tableColumns,
            tableData,
            happyUnhappy,
            hasFailedData,
            tableRowClick,
            handleCancel,
            confirmRequest,
            handleHappy,
            handleUnhappy,
            togleShowFailedData,
        } = this.SurveyDataImportStore
        return (
            <Panel>
                {Object.keys(responseMetadata).map((element) => (

                    <div style={{ display: 'flex' }}>
                        <p>
                            {`${element} : `}
                            <b>{responseMetadata[element]}</b>
                        </p>
                    </div>
                ))}
                <div style={{ display: 'flex' }}>
                    <p>Show failed records :</p>
                    <Checkbox style={{ marginLeft: '10px' }} onBlur={togleShowFailedData} />
                </div>
                <div className="result-btn">
                    {happyUnhappy ? (
                        <>
                            <Button cssClass="btn confirm-btn" onClick={handleHappy}>Happy</Button>
                            <Button cssClass="btn" onClick={handleUnhappy}>Unhappy</Button>
                        </>
                    ) : (
                        <>
                            {hasFailedData ? null : <Button cssClass="btn confirm-btn" onClick={confirmRequest}>Confirm</Button>}
                            <Button cssClass="btn" onClick={handleCancel}>Cancel</Button>
                        </>
                    )}
                </div>
                <div className="results_table">
                    <DataTable
                        store={{ filteredList: tableData }}
                        dataSet={tableData}
                        columns={tableColumns}
                        rowClick={tableRowClick}
                        rowId="id"
                        inMemory
                    />
                </div>
            </Panel>
        )
    }

    render() {
        const { uploadStarted } = this.SurveyDataImportStore
        return (
            <div id="surveyDataImport">
                <div>
                    {this.renderDetails()}
                </div>
                <div>
                    {uploadStarted ? this.renderResultPanel() : this.renderFilters()}
                </div>

            </div>
        )
    }
}
export default SurveyDataImport
